<template>
    <div class="my-3">
        <div class="d-flex justify-content-between">
            <h5 class="text-uppercase font-weight-bold ">Alerts</h5>
            <a
                class="text-primary font-weight-bold text-uppercase cursor-pointer ml-auto mr-2"
                style="cursor: pointer;"
                @click=""
            >
                <i class="fa fa-edit mr-2 "></i>
                Edit
            </a>
        </div>
        <div class="position-relative">
            <div class="row mb-2">
                <div class="col-6 px-0">
                    <progress-alert
                        :title="'2-3 word requests'"
                        :subtitle="'no data tracked'"
                        :progress="16"
                        :max="30"
                        :time="'days'"
                        :color="'#d5041d'"
                        :id="'pro1'"
                    ></progress-alert>
                </div>
                <div class="col-6 px-0">
                    <progress-alert
                        :title="'Identify array 3'"
                        :subtitle="'data progress slow'"
                        :progress="10"
                        :max="30"
                        :time="'days'"
                        :color="'#f3ba26'"
                        :id="'pro2'"
                    ></progress-alert>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-6 px-0">
                    <progress-alert
                        :title="'Assessment'"
                        :subtitle="'due'"
                        :progress="21"
                        :max="30"
                        :time="'days'"
                        :color="'#f3ba26'"
                        :id="'pro3'"
                    ></progress-alert>
                </div>
                <div class="col-6 px-0">
                    <progress-alert
                        :title="'Report'"
                        :subtitle="'due'"
                        :progress="48"
                        :max="90"
                        :time="'days'"
                        :color="'#79c81d'"
                        :id="'pro4'"
                    ></progress-alert>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProgressAlert from "./ProgressAlert";
export default {
    name: "PatientAlerts",
    components: {
        ProgressAlert,
    },
};
</script>

<style scoped></style>
